module.exports = __webpack_public_path__ + "assets/img/bg-2d54ed22.jpg";